import { FC } from 'react';
import { Box, Paper } from '@mui/material';
import { IBoardColumnShortDataUI, IColumnUI } from 'data/types/board.type';
import { Draggable } from 'react-beautiful-dnd';
import { ITaskUI } from 'data/types/task.type';
import ColumnHeader from './ColumnHeader';
import ColumnContent from './ColumnContent';

const BoardColumn: FC<{
  column: IColumnUI;
  width: number;
  boardId: string;
  projectId: string;
  index: number;
  tasks: ITaskUI[];
  setOpenedTask: (taskId: string) => void;
  dragLoading: boolean;
  allColumnsShortData: IBoardColumnShortDataUI[];
}> = ({
  column,
  width,
  boardId,
  projectId,
  index,
  tasks,
  setOpenedTask,
  dragLoading,
  allColumnsShortData,
}) => {
  // Use the column color directly as header background (these are already light colors)
  const headerBgColor = column.color || '#F1F5F9';

  return (
    <Draggable draggableId={column.documentId} index={index}>
      {provided => (
        <Paper
          {...provided.draggableProps}
          ref={provided.innerRef}
          elevation={0}
          sx={{
            width,
            minWidth: '280px',
            maxWidth: '320px',
            backgroundColor: '#F8FAFC',
            borderRadius: 3,
            border: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor: headerBgColor,
              borderBottom: '1px solid',
              borderColor: 'divider',
              px: 2,
              py: 1.5,
            }}
          >
            <ColumnHeader
              dragHandleProps={provided.dragHandleProps}
              column={column}
              boardId={boardId}
              projectId={projectId}
              allColumnsShortData={allColumnsShortData}
            />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              px: 1.5,
              py: 1.5,
              overflowY: 'auto',
            }}
          >
            <ColumnContent
              column={column}
              boardId={boardId}
              projectId={projectId}
              tasks={tasks}
              color={column.color}
              setOpenedTask={setOpenedTask}
              dragLoading={dragLoading}
            />
          </Box>
        </Paper>
      )}
    </Draggable>
  );
};

export default BoardColumn;
